module.exports = __webpack_public_path__ + "static/img/ubo_icon.d790cc95.png";